import { render, staticRenderFns } from "./vsRadio.vue?vue&type=template&id=970bbb56&lang=html&"
import script from "./vsRadio.vue?vue&type=script&lang=js&"
export * from "./vsRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsRadio.vue"
export default component.exports